var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "XS Icon Search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 19.537 19.537"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "search-green_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2377",
    fill: "#5a8127",
    d: "M0 0h19.537v19.537H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11726",
    clipPath: "url(#search-green_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 316",
    cx: 7.467,
    cy: 7.467,
    r: 7.467,
    transform: "translate(.75 .75)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 78",
    fill: "#5a8127",
    d: "M13.497 13.497l5.29 5.29"
  }))));
}

export default SvgSearchGreen;